module.exports = __webpack_public_path__ + "static/media/profile_avatar.eaf02c2d.png";